<!-- <vs-customer-account></vs-customer-account> -->
<ng-container
  *ngIf="user$ | async as user; else login"
  (clickOutside)="closeMenu($event)"
>
  <div
    (click)="openMenu($event)"
    id="userMenu"
    class="userName menu-list-items"
    *ngIf="user$ | async as user"
  >
    {{ user.firstName | uppercase | slice: 0:1 }}
    {{ user.lastName | uppercase | slice: 0:1 }}
  </div>
  <div *ngIf="menuToggle" class="userMenu">
    <div (click)="$event.stopPropagation()">
      <div class="userName" *ngIf="user$ | async as user">
        {{ user.firstName | uppercase | slice: 0:1 }}
        {{ user.lastName | uppercase | slice: 0:1 }}
      </div>

      <div
        *ngIf="user$ | async as user"
        class="text-center"
        (click)="$event.stopPropagation()"
      >
        <h3 class="pop_title">{{ user.name }}</h3>
        <div class="emailId">{{ user.email | lowercase }}</div>
        <hr />
      </div>
      <div *ngIf="node$ | async as node">
         
        <div
          mat-menu-item
          (click)="getItem(item, $event)"
          (click)="$event.stopPropagation()"
          *ngFor="let item of node?.children; let i = index"
          class="menu-list-items"
        >
          <div *ngIf="i + 1 == node?.children.length">
            <hr />
            <a (click)="logout()">
              <span class="material-icons icon-logout">
                power_settings_new
              </span>
              <div class="text-logout">
                {{ "userData.logOut" | cxTranslate }}
              </div>
            </a>
          </div>
          <div *ngIf="i + 1 != node?.children.length">
            {{ item.title }}
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #login>
  <div>
    <a role="link" [routerLink]="{ cxRoute: 'login' } | cxUrl" class="mr-30">{{
      "userData.loginBtn" | cxTranslate
    }}</a>
    <!-- Hidden until OKTA implementation. -->
    <a role="link" (click)="onRegisterClick()">{{
      "userData.registerBtn" | cxTranslate
    }}</a>
  </div>
</ng-template>

<vs-nav-bar-links [userType]="userTypeVal"></vs-nav-bar-links>
